<app-loader></app-loader>
<update-icon></update-icon>
<div class="logincontent">
  <ngx-simplebar style="height: 100%">
    <router-outlet></router-outlet>
  </ngx-simplebar>
</div>
